module.exports = __webpack_public_path__ + "img/home_page_img.7dbe5c33.jpg";